module.exports = {"step1":"Step 1","step2":"Step 2","step3":"Step 3","score":"Score","human_help":"Human help"}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/header/step.json
// module id = Zdx7
// module chunks = 23